import { z } from "zod";

export const OrderCategorySummarySchema = z.object({
  office: z.number().int().nonnegative(),
  with_comment: z.number().int().nonnegative(),
  pickup: z.number().int().nonnegative(),
});

export type OrderCategorySummary = z.infer<
  typeof OrderCategorySummarySchema
>;
